module.exports = __webpack_public_path__ + "img/ethereum classic.b9aba64a.svg";